'use client'

import Link from "next/link"
import Sidebar from "../layout/Sidebar"
import { createObjectActionPagePathname, createObjectPagePathname, createStaticPagePathname, getMediaUrl } from "@/services/pathname"
import { environments, thematics, sortDepartures, getNextSessions } from "@/services/holidayStay"
import Dropdown from "../form/Dropdown"
import moment from "moment"
import { useSearchParams, useRouter } from "next/navigation"
import React, { useState, useEffect, useId, useRef, ReactNode } from "react"
import { formatPrice } from "@/services/number"
import Checkbox from "../form/Checkbox"
import { toggleArrayElement } from "@/services/utils"
import { getName, getStaffByRole } from "@/services/aroeven"
import { parsePhone } from "@/services/text"
import { object, z } from 'zod'
import { messages } from '@/services/validation'
import { initRecaptcha } from "@/services/recaptcha/client"
import Loading from '../../../app/loading'
import { getDiscountCode, postBookingBafad, postBookingHolidayStay, postBookingPayment, postContactHolidayStay } from '@/api/helper'
import { checkRecaptcha } from '@/services/recaptcha/server'
import cardPaymentLogos from '@/assets/img/contenus/logos-cb.png'
import { status as s } from '@/services/status'
import DateMask from "../form/DateMask"
import { cardSystems } from "@/services/bank"
import { error } from "console"
import { accomodationTypes, levels } from "@/services/bafad"
import LoadingWithText from "../loading/LoadingWithText"
import DiscountCode from "../ui/DiscountCode"

const AdultParticipantSchema = z.object({
    isAdult: z.literal(true),
    gender: z.enum(['male', 'female'], {
        message: messages.required
    }),
    //administrationNumber: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    firstName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    lastName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    dateOfBirth: z.string().min(1, messages.required).date(messages.invalid),
    email: z.string().trim().min(1, messages.required).email(messages.email),
    //phones: z.array(z.string().trim().min(1, messages.required).min(10, messages.tooShort).max(255, messages.tooLong)).min(1, messages.required),
    address: z.object({
        address1: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        address2: z.string().trim().min(0, messages.required).max(255, messages.tooLong),
        postCode: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        city: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        country: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    }),
    agreesPhotos: z.boolean(),
    agreesSMS: z.boolean(),
    accomodationOption: z.any(),
    legalRepresentatives: z.array(z.object({}))
})
const MinorParticipantSchema = z.object({
    isAdult: z.literal(false),
    gender: z.enum(['male', 'female'], {
        message: messages.required
    }),
    //administrationNumber: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    firstName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    lastName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    dateOfBirth: z.string().min(1, messages.required).date(messages.invalid),
    email: z.string().min(0, messages.required).max(255, messages.tooLong),
    legalRepresentatives: z.array(
        z.object({
            type: z.enum(['mother', 'father', 'legalGuardian', 'other'], {
                message: messages.required
            }),
            civility: z.enum(['mr', 'mrs'], {
                message: messages.required
            }),
            firstName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
            lastName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
            email: z.string().trim().min(1, messages.required).email(messages.email),
            phones: z.array(z.string().trim().min(1, messages.required).min(10, messages.tooShort).max(255, messages.tooLong)).min(1, messages.required),
            address: z.object({
                address1: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
                address2: z.string().trim().min(0, messages.required).max(255, messages.tooLong),
                postCode: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
                city: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
                country: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
            })
        }),
    ).min(1, messages.required),
    agreesPhotos: z.boolean(),
    agreesSMS: z.boolean(),
    accomodationOption: z.any(),
})
const BookingSchema = z.object({
    customerType: z.enum(['individual', 'professional']),
    participants: z.array(
        z.discriminatedUnion('isAdult', [
            AdultParticipantSchema,
            MinorParticipantSchema
        ])
    ).min(1, messages.required).superRefine((participants, refinementContext) => {
        participants.map((participant, indexParticipant) => {
            if (participant.isAdult === false) {
                participant.legalRepresentatives.map((legalRepresentative, indexLegalRepresentative) => {
                    if (legalRepresentative.email.trim() === participant.email.trim()) {
                        refinementContext.addIssue({
                            code: z.ZodIssueCode.custom,
                            message: "Les adresses email du participant et de son responsable légal doivent être différentes",
                            path: [indexParticipant, 'legalRepresentatives', indexLegalRepresentative, 'email'],
                        })
                    }
                })
            }
        })
        return refinementContext
    }),
    withInsurance: z.boolean(),
    financialAid: z.object({
        caf: z.object({
            beneficiaryNumber: z.string().optional(),
            deparment: z.string().optional(),
            active: z.boolean()
        }),
        msa: z.object({
            beneficiaryNumber: z.string().optional(),
            deparment: z.string().optional(),
            active: z.boolean()
        }),
        other: z.string().optional()
    }),
    termsOfSale: z.enum(['accepted'], {
        message: messages.required
    }),
    payment: z.object({
        mode: z.enum(['card', 'other']),
        amountMode: z.enum(['full', 'deposit']),
        //amount: z.number().nonnegative()
    })
})
const ProfessionalSchema = z.object({
    companyName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    companyNumber: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    email: z.string().trim().min(1, messages.required).email(messages.email),
    phones: z.array(z.string().trim().min(1, messages.required).min(10, messages.tooShort).max(255, messages.tooLong)).min(1, messages.required),
    address: z.object({
        address1: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        address2: z.string().trim().min(0, messages.required).max(255, messages.tooLong),
        postCode: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        city: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        country: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    }),
    contact: z.object({
        civility: z.enum(['mr', 'mrs'], {
            message: messages.required
        }),
        firstName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        lastName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        email: z.string().trim().min(1, messages.required).email(messages.email),
        phones: z.array(z.string().trim().min(1, messages.required).min(10, messages.tooShort).max(255, messages.tooLong)).min(1, messages.required),
        address: z.object({
            address1: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
            address2: z.string().trim().min(0, messages.required).max(255, messages.tooLong),
            postCode: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
            city: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
            country: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        }),
    })
})
const IndividualSchema = z.object({
    civility: z.enum(['mr', 'mrs'], {
        message: messages.required
    }),
    firstName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    lastName: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    email: z.string().trim().min(1, messages.required).email(messages.email),
    phones: z.array(z.string().trim().min(1, messages.required).min(10, messages.tooShort).max(255, messages.tooLong)).min(1, messages.required),
    address: z.object({
        address1: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        address2: z.string().trim().min(0, messages.required).max(255, messages.tooLong),
        postCode: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        city: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
        country: z.string().trim().min(1, messages.required).max(255, messages.tooLong),
    })
})

type BookingProps = {
    aroeven: Aroeven,
    bafad: Bafad
}

type Person = {
    firstName: string,
    lastName: string,
    civility: string,
    email: string,
    phones: string[],
    address: {
        address1: string,
        address2: string,
        postCode: string,
        city: string,
        country: string
    }
}

type Participant = {
    id: number,
    administrationNumber: string,
    firstName: string,
    lastName: string,
    gender: string,
    dateOfBirth: string,
    isAdult: boolean,
    email: string,
    phones: string[],
    options: BafadOption[],
    accomodationOption: BafadAccomodationOption
    legalRepresentatives: LegalRepresentative[],
    agreesPhotos: boolean,
    agreesSMS: boolean,
    address: {
        address1: string,
        address2: string,
        postCode: string,
        city: string,
        country: string
    },
    discountCodes: DiscountCode[]
}

type LegalRepresentative = Person & {
    id: number,
    type: string,
    agreesSMS: boolean,
    message: string
}

type Professional = Person & {
    id: number,
    type: string,
    companyName: string,
    companyNumber: string,
    contact: Person,
    message: string
}

type Individual = Person & {
    id: number,
    isLegalRepresentative: boolean
}

type Booking = {
    customerType: 'individual' | 'professional',
    participants: Participant[],
    professional: Professional,
    individual: Individual,
    //options: string[],
    withInsurance: boolean,
    financialAid: {
        caf: {
            active: boolean,
            department: string,
            beneficiaryNumber: string
        },
        msa: {
            active: boolean,
            department: string,
            beneficiaryNumber: string
        },
        other: string
    },
    termsOfSale: string,
    payment: {
        mode: string,
        amountMode: string
    }
}

export default function Booking({
    aroeven,
    bafad
}: BookingProps) {

    const searchParams = useSearchParams()
    const { replace } = useRouter()

    const [status, setStatus] = useState<string>(s.idle)
    const [statusText, setStatusText] = useState<ReactNode | string>('')
    const [errors, setErrors] = useState<any[]>([])
    const [serverError, setServerError] = useState<any>(null)
    const [paymentParams, setPaymentParams] = useState<{ params: Record<string, string>, url: string }>(null)
    const refPaymentForm = useRef<HTMLFormElement>()

    const refAccordions = useRef<HTMLDivElement>()

    const paymentModeRadioId = useId()

    const newLegalRepresentative = {
        id: null,
        type: '',
        firstName: '',
        lastName: '',
        civility: '',
        email: '',
        phones: [''],
        agreesSMS: false,
        maritalStatus: '',
        address: {
            address1: '',
            address2: '',
            postCode: '',
            city: '',
            country: 'France'
        },
        message: '',
    }

    const newParticipant = {
        id: null,
        administrationNumber: '',
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        isAdult: false,
        email: '',
        phones: [''],
        agreesSMS: false,
        options: [],
        accomodationOption: bafad.accomodationOptions.filter(o => searchParams.get('accomodationOption') === o.id)[0] ?? bafad.accomodationOptions[0],
        legalRepresentatives: [{
            ...newLegalRepresentative
        }],
        agreesPhotos: true,
        address: {
            address1: '',
            address2: '',
            postCode: '',
            city: '',
            country: 'France'
        },
        discountCodes: []
    }

    const [booking, setBooking] = useState<Booking>({
        customerType: 'individual',
        participants: [{
            ...newParticipant
        }],
        professional: {
            id: null,
            type: '',
            firstName: '',
            lastName: '',
            civility: '',
            email: '',
            phones: [''],
            address: {
                address1: '',
                address2: '',
                postCode: '',
                city: '',
                country: 'France'
            },
            companyName: '',
            companyNumber: '',
            contact: {
                firstName: '',
                lastName: '',
                civility: '',
                email: '',
                phones: [''],
                address: {
                    address1: '',
                    address2: '',
                    postCode: '',
                    city: '',
                    country: 'France'
                }
            },
            message: ''
        },
        individual: {
            id: null,
            isLegalRepresentative: true,
            civility: '',
            firstName: '',
            lastName: '',
            email: '',
            phones: [''],
            address: {
                address1: '',
                address2: '',
                postCode: '',
                city: '',
                country: 'France'
            }
        },
        withInsurance: false,
        financialAid: {
            caf: {
                active: false,
                department: '',
                beneficiaryNumber: ''
            },
            msa: {
                active: false,
                department: '',
                beneficiaryNumber: ''
            },
            other: ''
        },
        termsOfSale: '',
        payment: {
            mode: bafad.proposedBy.paymentCardSystem in cardSystems ? 'card' : 'other',
            amountMode: 'full',
        }
    })

    /*if (process.env.NODE_ENV !== 'production') {
        useEffect(() => {
            setBooking({

                customerType: 'individual',
                participants: [{
                    id: null,
                    firstName: 'Thibaut',
                    lastName: 'Sagi',
                    gender: 'M',
                    dateOfBirth: '1987-06-02',
                    email: '',
                    phone: '',
                    agreesSMS: true,
                    options: [],
                    accomodationOption: bafad.accomodationOptions.filter(o => searchParams.get('accomodationOption') === o.id)[0] ?? bafad.accomodationOptions[0],
                    legalRepresentatives: [{
                        id: null,
                        type: 'father',
                        firstName: 'Alain',
                        lastName: 'Sagi',
                        civility: 'M',
                        email: 'sagi.thibaut@gmail.com',
                        phones: ['0672444223'],
                        agreesSMS: false,
                        address: {
                            address1: '27 impasse Fleming',
                            address2: '',
                            postCode: '40280',
                            city: 'Saint-Pierre-du-Mont',
                            country: 'France'
                        },
                        message: '',
                        payer: false
                    }],
                    agreesPhotos: false
                }],
                professional: {
                    id: null,
                    type: '',
                    firstName: '',
                    lastName: '',
                    civility: '',
                    email: '',
                    phones: [''],
                    address: {
                        address1: '',
                        address2: '',
                        postCode: '',
                        city: '',
                        country: 'France'
                    },
                    companyName: '',
                    companyNumber: '',
                    contact: {
                        firstName: '',
                        lastName: '',
                        civility: '',
                        email: '',
                        phones: [''],
                        address: {
                            address1: '',
                            address2: '',
                            postCode: '',
                            city: '',
                            country: 'France'
                        },
                        companyName: '',
                        contactName: '',
                        contactEmail: '',
                        contactPhone: ''
                    },
                    message: ''
                },
                individual: {
                    id: null,
                    isLegalRepresentative: true,
                    civility: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    phones: [''],
                    address: {
                        address1: '',
                        address2: '',
                        postCode: '',
                        city: '',
                        country: 'France'
                    }
                },
                withInsurance: false,
                financialAid: {
                    caf: {
                        active: false,
                        department: '',
                        beneficiaryNumber: ''
                    },
                    msa: {
                        active: false,
                        department: '',
                        beneficiaryNumber: ''
                    },
                    other: ''
                },
                termsOfSale: '',
                payment: {
                    mode: 'other',
                    amountMode: 'full',
                }
            })
        }, [])
    }*/

    useEffect(() => {
        async function load() {
            const bootstrap = (await import('bootstrap/dist/js/bootstrap')).default;
            refAccordions.current.querySelectorAll('.collapse').forEach((collapse) => {
                new bootstrap.Collapse(collapse, {
                    toggle: false
                })
            })
        }
        load()
    }, [])

    useEffect(() => {
        console.log('PAYMENT PARAMS USE EFFECT',)
        if (!paymentParams) return
        if (!refPaymentForm.current) return
        refPaymentForm.current.submit()
    }, [paymentParams])

    function setParticipant(index: number, participant) {
        setBooking({
            ...booking,
            participants: Object.assign(
                [...booking.participants], {
                [index]: participant
            })
        })
    }

    async function sendBooking() {
        console.log(booking)

        setErrors([])
        setServerError(null)
        let errors = []
        try {
            BookingSchema.parse(booking)
        }
        catch (error) {
            console.log(error.issues)
            errors = [...errors, ...error.issues]
        }
        if (booking.customerType === 'professional') {
            try {
                ProfessionalSchema.parse(booking.professional)
            }
            catch (error) {
                errors = [...errors, ...error.issues.map(issue => ({
                    ...issue,
                    path: ['professional', ...issue.path]
                }))]
            }
        }
        if (booking.customerType === 'individual' && booking.individual.isLegalRepresentative === false) {
            try {
                IndividualSchema.parse(booking.individual)
            }
            catch (error) {
                errors = [...errors, ...error.issues.map(issue => ({
                    ...issue,
                    path: ['individual', ...issue.path]
                }))]
            }
        }

        if (errors.length > 0) {
            setErrors(errors)
            return
        }

        setStatus(s.loading)
        setStatusText('Nous vérifions votre réservation...')
        try {
            await initRecaptcha(async (token: string) => {
                console.log(token)
                try {
                    const result = await checkRecaptcha(token)
                    if (result.success === false) {
                        setStatus(s.error)
                        setServerError('recaptcha')
                        return
                    }

                    const {
                        individual,
                        professional,
                        customerType,
                        payment: formPayment,
                        ...formBooking
                    } = booking

                    let updatedBooking = null
                    try {
                        updatedBooking = await postBookingBafad(aroeven, bafad, {
                            ...formBooking,
                            participants: formBooking.participants.map((participant: Participant) => ({
                                ...participant,
                                accomodationOption: participant.accomodationOption['@id'],
                                options: participant.options.map(o => o['@id']),
                                discountCodes: participant.discountCodes.map(c => c.code)
                            })),
                            ...(booking.customerType === 'professional' || booking.individual.isLegalRepresentative === false) && {
                                customer: {
                                    ...booking.customerType === 'individual' ? individual : professional,
                                    type: customerType
                                }
                            },
                            paymentMode: booking.payment.mode
                        })
                    }
                    catch (error) {
                        setServerError('registration')
                        setStatus(s.error)
                        setStatusText('')
                        return
                    }

                    console.log('updatedBooking', updatedBooking)

                    if (updatedBooking === null) {
                        setServerError('registration')
                        setStatus(s.error)
                        setStatusText('')
                        return
                    }

                    if ('error' in updatedBooking) {
                        setServerError(updatedBooking.error)
                        setStatus(s.error)
                        setStatusText('')
                        return
                    }

                    setStatusText('Votre réservation est enregistrée !')

                    if (booking.payment.mode !== 'card') {
                        console.log('replace vers confirmation')
                        replace(createStaticPagePathname('Common', 'BookingConfirmation') + '?booking=' + updatedBooking.id)
                        return
                    }

                    let payment = null
                    try {
                        payment = await postBookingPayment(aroeven, updatedBooking, {
                            expectedAmount: getPayableAmount()
                        })
                    }
                    catch (error) {
                        replace(createStaticPagePathname('Common', 'BookingConfirmation') + '?booking=' + updatedBooking.id)
                        return
                    }

                    console.log('payment', payment)

                    if (payment === null) {
                        replace(createStaticPagePathname('Common', 'BookingConfirmation') + '?booking=' + updatedBooking.id)
                        return
                    }

                    setStatusText(<>Votre réservation est enregistrée ! <br />Vous allez être redirigé.e vers la page de paiement de notre partenaire bancaire...</>)

                    setTimeout(() => {
                        setPaymentParams({
                            params: payment.params,
                            url: payment.url
                        })
                    }, 2000)
                }
                catch (error) {
                    console.log(error)
                    setStatus(s.error)
                    setServerError('booking')
                    setStatusText('')
                    return
                }
            })
        }
        catch (error) {
            console.log(error)
            setStatus(s.error)
            setServerError('recaptcha')
            setStatusText('')
            return
        }
    }

    const totalPrice = Math.max(0, booking.participants.reduce((participants: number, participant: Participant) => participants + participant.accomodationOption.price + participant.options.reduce((sum, option) => sum + option.price, 0) + participant.discountCodes.reduce((sum, discountCode) => sum - (discountCode.rate ? Math.ceil(participant.accomodationOption.price * discountCode.rate) : discountCode.amount), 0) + (booking.withInsurance ? participant.accomodationOption.insurancePrice : 0), 0))

    function getPayableAmount() {
        let payableAmount: number = 0
        if (booking.payment.mode === 'card') {
            payableAmount = totalPrice
            if (booking.payment.amountMode === 'deposit') {
                payableAmount = payableAmount * 0.3
            }
        }
        return Math.ceil(payableAmount)
    }

    const cancelationInsuranceTermsLink = bafad.proposedBy.url + '/bafa-bafd/procedures-administratives/assurance-annulation-optionnelle'

    return (
        <>
            {status === s.loading &&
                <LoadingWithText text={statusText} />
            }
            <section className="breadcrumb py-10 d-flex items-left">
                <div className="container">
                    <div className="col-auto lh-14">
                        <i className="fi fi-rr-arrow-small-left" />
                        Retour à la description <Link href={createObjectPagePathname('Bafad', bafad)} className="link white text-white">{levels[bafad.level]?.name}</Link>
                    </div>
                </div>
            </section>
            <section className="heading pt-20">
                <div className="container">
                    <div className="row">
                        <div className="col-12" />
                    </div>
                </div>
                <div className="container p-10 pt-0">
                    <div className="row y-gap-30">
                        <div className="col-lg-7 col-xl-8">
                            <div className="row justify-between items-end">
                                <div className="col-auto">
                                    <h1>Réservation de votre formation</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="curve" />
            </section>
            <section className="content pt-0">
                <div className="container">
                    <div className="row y-gap-30">
                        <div className="steps col-lg-7 col-xl-8 order-last order-lg-1">
                            {/*
                            <div className="condition px-24 py-20 bg-bloc mt-30 mb-20">
                                <div className="row y-gap-30 justify-between items-center">
                                    <div className="col-auto">
                                        <p className="m-0 text-primary-4">
                                            <i className="fi fi-rr-circle-user" />
                                            Vous possédez déjà un compte chez nous ? Connectez-vous
                                            pour récupérer vos informations.
                                        </p>
                                    </div>
                                    <div className="col-auto w-100 pt-0 connexion align-items-center">
                                        <div className="form-input">
                                            <input type="text" required />
                                            <label className="lh-1 text-light-1">Adresse email</label>
                                        </div>
                                        <div className="form-input">
                                            <input type="text" required />
                                            <label className="lh-1 text-light-1">Mot de passe</label>
                                        </div>
                                        <div className="col-auto pt-0 connexion align-items-center">
                                            <a href="#" className="link voirtout">Mot de passe oublié ?</a>
                                        </div>
                                        <div>
                                            <button className="mainSearch__submit button col-12 text-primary">
                                                <span className="lancerrecherche mr-10 d-lg-none">
                                                    Se connecter
                                                </span>
                                                <i className="fi fi-ss-arrow-alt-circle-right" />
                                            </button>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                            */}
                            <div className="row x-gap-20 y-gap-20 mb-10">
                                <div className="col-auto">
                                    <label className="lh-1 text-light-1">Je suis :</label>
                                </div>
                                <div className="col-auto">
                                    <div className="d-flex items-center">
                                        <div className="radio-wrapper">
                                            <input type="radio" id="booking_customerType_individual" checked={booking.customerType === 'individual'} onChange={() => {
                                                setBooking({
                                                    ...booking,
                                                    customerType: 'individual'
                                                })
                                            }} />
                                            <label htmlFor="booking_customerType_individual" className="mr-20">
                                                <span />
                                                Une personne physique
                                            </label>
                                            <input type="radio" id="booking_customerType_professional" checked={booking.customerType === 'professional'} onChange={() => {
                                                setBooking({
                                                    ...booking,
                                                    customerType: 'professional'
                                                })
                                            }} />
                                            <label htmlFor="booking_customerType_professional">
                                                <span />
                                                Une entité
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion accordion-flush" ref={refAccordions}>
                                <div className="accordion-item bg-bloc mb-30">
                                    <h2 className="accordion-header" id="booking_participants_accordion_heading">
                                        <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_participants_accordion_content" aria-expanded="true" aria-controls="booking_participants_accordion_content">
                                            <div className="d-flex items-center">
                                                <div className={"size-40 flex-center" + (errors.filter(e => e.path.join('-').indexOf('participants') === 0).length > 0 ? ' text-terracotta' : '')}>
                                                    <i className="fi fi-ss-circle-1" />
                                                </div>
                                                <div className={"ml-10" + (errors.filter(e => e.path.join('-').indexOf('participants') === 0).length > 0 ? ' text-terracotta' : '')}>
                                                    Informations sur le{booking.participants.length > 1 ? 's' : ''} participant{booking.participants.length > 1 ? 's' : ''}
                                                </div>
                                            </div>
                                        </button>
                                    </h2>
                                    <div id="booking_participants_accordion_content" className="accordion-collapse collapse show" aria-labelledby="booking_participants_accordion_heading">
                                        <div className="accordion-body">
                                            {booking.participants.map((participant, indexParticipant) => {
                                                return (
                                                    <React.Fragment key={"participant-" + indexParticipant}>
                                                        {booking.participants.length > 1 &&
                                                            <div className="d-flex justify-content-between titre-participant pe-0">
                                                                <div>{(participant.firstName + ' ' + participant.lastName).trim() ? (participant.firstName + ' ' + participant.lastName).trim() : 'Participant ' + (indexParticipant + 1)}</div>
                                                                <button className='btn text-white' onClick={() => {
                                                                    setBooking({
                                                                        ...booking,
                                                                        participants: Object.assign(
                                                                            [...booking.participants], {
                                                                            [indexParticipant]: null
                                                                        }
                                                                        ).filter(participant => participant)
                                                                    })
                                                                }}><i className='fi fi-rr-trash' /></button>
                                                            </div>
                                                        }
                                                        <Participant
                                                            participant={participant}
                                                            setParticipant={(participant) => setParticipant(indexParticipant, participant)}
                                                            bafad={bafad}
                                                            booking={booking}
                                                            errors={errors}
                                                            errorPrefix={'participants-' + indexParticipant + '-'}
                                                        />
                                                    </React.Fragment>
                                                )
                                            })}
                                            {/*<div className="row y-gap-20 pt-20 items-center justify-between">
                                                <div className="col-auto">
                                                    <button className="button-outline d-block w-100" onClick={(e) => {
                                                        setBooking({
                                                            ...booking,
                                                            participants: [
                                                                ...booking.participants,
                                                                { ...newParticipant }
                                                            ]
                                                        })
                                                    }}>
                                                        <i className="fi fi-rr-plus mr-5" />
                                                        Ajouter un autre participant
                                                    </button>
                                                </div>
                                                <div className="col-auto">
                                                    <a href="#" className="button-primary bg-primary d-block w-100">
                                                        Enregistrer
                                                    </a>
                                                </div>
                                            </div>*/}
                                            {/*<div className="row y-gap-20 items-center justify-between pt-0">
                                                <div className="col-auto">
                                                    <div className="text-14 text-light-1">
                                                        Dans le cadre d’un séjour en Famille, indiquer
                                                        chaque membre, même les adultes.
                                                    </div>
                                                </div>
                                            </div>*/}
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="accordion-item bg-bloc mb-30">
                                    <h2 className="accordion-header" id="booking_legalRepresentatives_accordion_heading">
                                        <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_legalRepresentatives_accordion_content" aria-expanded="false" aria-controls="booking_legalRepresentatives_accordion_content">
                                            <div className="size-40 flex-center">
                                                <i className="fi fi-ss-circle-2" />
                                            </div>
                                            <div className="ml-10">
                                                Information sur le{booking.legalRepresentatives.length > 1 && <>s</>} responsable{booking.legalRepresentatives.length > 1 && <>s</>} léga{booking.legalRepresentatives.length > 1 ? <>ux</> : <>l</>}
                                            </div>
                                        </button>
                                    </h2>
                                    <div id="booking_legalRepresentatives_accordion_content" className="accordion-collapse collapse" aria-labelledby="booking_legalRepresentatives_accordion_heading">
                                        <div className="accordion-body">
                                            {booking.legalRepresentatives.map((legalRepresentative, indexLegalRepresentative) => {
                                                return (
                                                    <React.Fragment key={"legalRepresentative-" + indexLegalRepresentative}>
                                                        {booking.legalRepresentatives.length > 1 &&
                                                            <div className="d-flex justify-content-between titre-participant pe-0">
                                                                <div>{(legalRepresentative.firstName + ' ' + legalRepresentative.lastName).trim() ? (legalRepresentative.firstName + ' ' + legalRepresentative.lastName).trim() : 'Représentant légal ' + (indexLegalRepresentative + 1)}</div>
                                                                <button className='btn text-white' onClick={() => {
                                                                    setBooking({
                                                                        ...booking,
                                                                        legalRepresentatives: Object.assign(
                                                                            [...booking.legalRepresentatives], {
                                                                            [indexLegalRepresentative]: null
                                                                        }
                                                                        ).filter(legalRepresentative => legalRepresentative)
                                                                    })
                                                                }}><i className='fi fi-rr-trash' /></button>
                                                            </div>
                                                        }
                                                        <LegalRepresentative
                                                            booking={booking}
                                                            legalRepresentative={legalRepresentative}
                                                            setLegalRepresentative={(legalRepresentative) => setLegalRepresentative(indexLegalRepresentative, legalRepresentative)}
                                                            errors={errors}
                                                        />
                                                    </React.Fragment>
                                                )
                                            })}
                                            <div className="row y-gap-20 pt-20 items-center justify-between">
                                                <div className="col-auto">
                                                    <button className="button-secondary d-block w-100" onClick={(e) => {
                                                        setBooking({
                                                            ...booking,
                                                            legalRepresentatives: [
                                                                ...booking.legalRepresentatives,
                                                                { ...newLegalRepresentative }
                                                            ]
                                                        })
                                                    }}>
                                                        <i className="fi fi-rr-plus mr-5" />
                                                        Ajouter un autre responsable
                                                    </button>
                                                </div>
                                                <div className="col-auto">
                                                    <a href="#" className="button-primary bg-primary d-block w-100">
                                                        Enregistrer
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>*/}
                                {booking.customerType === 'professional' &&
                                    <div className="accordion-item bg-bloc mb-30">
                                        <h2 className="accordion-header" id="booking_professional_accordion_heading">
                                            <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_professional_accordion_content" aria-expanded="false" aria-controls="booking_professional_accordion_content">
                                                <div className={"size-40 flex-center" + (errors.filter(e => e.path.join('-').indexOf('professional') === 0).length > 0 ? ' text-terracotta' : '')}>
                                                    <i className="fi fi-ss-circle-2" />
                                                </div>
                                                <div className={"ml-10 " + (errors.filter(e => e.path.join('-').indexOf('professional') === 0).length > 0 ? ' text-terracotta' : '')}>Informations sur l'entité</div>
                                            </button>
                                        </h2>
                                        <div id="booking_professional_accordion_content" className="accordion-collapse collapse" aria-labelledby="booking_professional_accordion_heading">
                                            <div className="accordion-body">
                                                {/*<div className="row x-gap-20 y-gap-20 pt-10">
                                                    <div className="col-md-6">
                                                        <Dropdown
                                                            withLabel={false}
                                                            options={{
                                                                cat1: 'Catégorie 1',
                                                                cat2: 'Catégorie 2',
                                                            }}
                                                            placeholder={<><span className="js-button-title">
                                                                Catégorie
                                                                <span className="obligatoire">*</span>
                                                            </span>
                                                            </>}
                                                            value={booking.professional.type}
                                                            nullable={false}
                                                            multiple={false}
                                                            search={false}
                                                            onChange={(type: string) => {
                                                                setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        professional: {
                                                                            ...booking.professional,
                                                                            type
                                                                        }
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="divider" />*/}
                                                <div className="row x-gap-20 y-gap-20 pt-0">
                                                    {/*<h3>Informations sur l'entité</h3>*/}
                                                    {/*<div className="col-md-2">
                                                        <Dropdown
                                                            withLabel={false}
                                                            className="small"
                                                            options={{
                                                                mrs: 'Mme',
                                                                mr: 'M.',
                                                            }}
                                                            placeholder="..."
                                                            value={booking.professional.civility}
                                                            nullable={false}
                                                            multiple={false}
                                                            search={false}
                                                            onChange={(civility: string) => {
                                                                setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        professional: {
                                                                            ...booking.professional,
                                                                            civility
                                                                        }
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>*/}
                                                    {/*<div className="col-md-5">
                                                        <div className="form-input">
                                                            <input type="text" required value={booking.professional.firstName} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        firstName: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Prénom
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-input">
                                                            <input type="text" required value={booking.professional.lastName} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        lastName: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Nom
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                    </div>*/}
                                                    <div className="col-md-12">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-companyName').length > 0 ? ' requis' : ''} value={booking.professional.companyName} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    companyName: e.target.value
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Raison sociale ou dénomination
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-companyName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-companyName')[0].message}</div>}
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-companyNumber').length > 0 ? ' requis' : ''} value={booking.professional.companyNumber} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    companyNumber: e.target.value
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Numéro SIRET
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-companyNumber').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-companyNumber')[0].message}</div>}
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-address-address1').length > 0 ? ' requis' : ''} value={booking.professional.address.address1} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    address: {
                                                                        ...booking.professional.address,
                                                                        address1: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                N° et nom de rue
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-address-address1').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-address-address1')[0].message}</div>}
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-input">
                                                            <input type="text" required value={booking.professional.address.address2} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    address: {
                                                                        ...booking.professional.address,
                                                                        address2: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Complément d'adresse
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-address-postCode').length > 0 ? ' requis' : ''} value={booking.professional.address.postCode} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    address: {
                                                                        ...booking.professional.address,
                                                                        postCode: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Code postal
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-address-postCode').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-address-postCode')[0].message}</div>}
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-address-city').length > 0 ? ' requis' : ''} value={booking.professional.address.city} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    address: {
                                                                        ...booking.professional.address,
                                                                        city: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Commune
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-address-city').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-address-city')[0].message}</div>}
                                                    </div>
                                                    <div className="col-md-4">
                                                        {/*<div className="select small libelle js-select" data-select-value>
                                                            <button className="select__button js-button">
                                                                <span className="js-button-title">Pays</span>
                                                                <i className="fi fi-bs-angle-down text-primary-4" />
                                                            </button>
                                                            <div className="select__dropdown js-dropdown">
                                                                <div className="select__options js-options">
                                                                    <div className="select__options__button" data-value>
                                                                        Pays 2
                                                                    </div>
                                                                    <div className="select__options__button" data-value>
                                                                        Pays 3
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>*/}
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-address-country').length > 0 ? ' requis' : ''} value={booking.professional.address.country} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    address: {
                                                                        ...booking.professional.address,
                                                                        country: e.target.value
                                                                    }
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Pays
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-address-country').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-address-country')[0].message}</div>}
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-phones-0').length > 0 ? ' requis' : ''} value={booking.professional.phones[0] ?? ''} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    phones: [e.target.value]
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                N° de téléphone
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-phones-0').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-phones-0')[0].message}</div>}
                                                    </div>
                                                    <div className="col-md-7">
                                                        <div className="form-input">
                                                            <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-email').length > 0 ? ' requis' : ''} value={booking.professional.email} onChange={(e) => setBooking({
                                                                ...booking,
                                                                professional: {
                                                                    ...booking.professional,
                                                                    email: e.target.value
                                                                }
                                                            })} />
                                                            <label className="lh-1 text-light-1">
                                                                Adresse email
                                                                <span className="obligatoire">*</span>
                                                            </label>
                                                        </div>
                                                        {errors.filter(e => e.path.join('-') === 'professional-email').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-email')[0].message}</div>}
                                                    </div>
                                                </div>
                                                {/*<div className="divider" />
                                                <div className="row x-gap-20 y-gap-20">
                                                    <div className="col-12">
                                                        <div className="form-input">
                                                            <textarea required rows={6} value={booking.professional.message} onChange={(e) => {
                                                                setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        message: e.target.value
                                                                    }
                                                                })
                                                            }} />
                                                            <label className="lh-1 text-light-1">
                                                                Autre information que vous souhaiteriez
                                                                transmettre
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>*/}
                                                {/*<div className="row x-gap-20 y-gap-20 pt-0">
                                                    <div className="col-md-12">
                                                        <div className="d-flex items-center">
                                                            <div className="form-switch d-flex items-center">
                                                                <div className="switch" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                                                    <input type="checkbox" />
                                                                    <span className="switch__slider" />
                                                                </div>
                                                                <div className="lh-1 ml-10">
                                                                    Saisir les coordonnées d'un correspondant (pour
                                                                    l'envoi des renseignements concernant le départ)
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>*/}
                                                <div className="divider" />
                                                <div className="collapse show" id="collapseExample">
                                                    <div className="row x-gap-20 y-gap-20 pt-0">
                                                        <h3>Informations sur le correspondant</h3>
                                                        <div className="col-md-2">
                                                            <Dropdown
                                                                withLabel={false}
                                                                className={"small" + (errors.filter(e => e.path.join('-') === 'professional-contact-civility').length > 0 ? ' requis' : '')}
                                                                options={{
                                                                    mrs: 'Mme',
                                                                    mr: 'M.',
                                                                }}
                                                                placeholder="..."
                                                                value={booking.professional.contact.civility}
                                                                nullable={false}
                                                                multiple={false}
                                                                search={false}
                                                                onChange={(civility: string) => {
                                                                    setBooking({
                                                                        ...booking,
                                                                        professional: {
                                                                            ...booking.professional,
                                                                            contact: {
                                                                                ...booking.professional.contact,
                                                                                civility
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-civility').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-civility')[0].message}</div>}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-firstName').length > 0 ? ' requis' : ''} value={booking.professional.contact.firstName} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            firstName: e.target.value
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Prénom
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-firstName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-firstName')[0].message}</div>}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-lastName').length > 0 ? ' requis' : ''} value={booking.professional.contact.lastName} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            lastName: e.target.value
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Nom
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-lastName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-lastName')[0].message}</div>}
                                                        </div>
                                                        {/*<div className="col-md-12">
                                                                                                                    <div className="form-input">
                                                                                                                        <input type="text" required value={booking.professional.contact.companyName} onChange={(e) => setBooking({
                                                                                                                            ...booking,
                                                                                                                            professional: {
                                                                                                                                ...booking.professional,
                                                                                                                                contact: {
                                                                                                                                    ...booking.professional.contact,
                                                                                                                                    companyName: e.target.value
                                                                                                                                }
                                                                                                                            }
                                                                                                                        })} />
                                                                                                                        <label className="lh-1 text-light-1">
                                                                                                                            Raison sociale
                                                                                                                            <span className="obligatoire">*</span>
                                                                                                                        </label>
                                                                                                                    </div>
                                                                                                                </div>*/}
                                                        <div className="col-12">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-address-address1').length > 0 ? ' requis' : ''} value={booking.professional.contact.address.address1} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            address: {
                                                                                ...booking.professional.contact.address,
                                                                                address1: e.target.value
                                                                            }
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    N° et nom de rue
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-address-address1').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-address-address1')[0].message}</div>}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="form-input">
                                                                <input type="text" value={booking.professional.contact.address.address2} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            address: {
                                                                                ...booking.professional.contact.address,
                                                                                address2: e.target.value
                                                                            }
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Complément d'adresse
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-address-postCode').length > 0 ? ' requis' : ''} value={booking.professional.contact.address.postCode} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            address: {
                                                                                ...booking.professional.contact.address,
                                                                                postCode: e.target.value
                                                                            }
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Code postal
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-address-postCode').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-address-postCode')[0].message}</div>}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-address-city').length > 0 ? ' requis' : ''} value={booking.professional.contact.address.city} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            address: {
                                                                                ...booking.professional.contact.address,
                                                                                city: e.target.value
                                                                            }
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Commune
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-address-city').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-address-city')[0].message}</div>}
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<div className="select small libelle js-select" data-select-value>
                                                                                                                    <button className="select__button js-button">
                                                                                                                        <span className="js-button-title">Pays</span>
                                                                                                                        <i className="fi fi-bs-angle-down text-primary-4" />
                                                                                                                    </button>
                                                                                                                    <div className="select__dropdown js-dropdown">
                                                                                                                        <div className="select__options js-options">
                                                                                                                            <div className="select__options__button" data-value>
                                                                                                                                Pays 2
                                                                                                                            </div>
                                                                                                                            <div className="select__options__button" data-value>
                                                                                                                                Pays 3
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>*/}
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-address-country').length > 0 ? ' requis' : ''} value={booking.professional.contact.address.country} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            address: {
                                                                                ...booking.professional.contact.address,
                                                                                country: e.target.value
                                                                            }
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Pays
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-address-country').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-address-country')[0].message}</div>}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-phones-0').length > 0 ? ' requis' : ''} value={booking.professional.contact.phones[0] ?? ''} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            phones: [e.target.value]
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    N° de téléphone
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-phones-0').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-phones-0')[0].message}</div>}
                                                        </div>
                                                        <div className="col-md-7">
                                                            <div className="form-input">
                                                                <input type="text" className={errors.filter(e => e.path.join('-') === 'professional-contact-email').length > 0 ? ' requis' : ''} value={booking.professional.contact.email} onChange={(e) => setBooking({
                                                                    ...booking,
                                                                    professional: {
                                                                        ...booking.professional,
                                                                        contact: {
                                                                            ...booking.professional.contact,
                                                                            email: e.target.value
                                                                        }
                                                                    }
                                                                })} />
                                                                <label className="lh-1 text-light-1">
                                                                    Adresse email
                                                                    <span className="obligatoire">*</span>
                                                                </label>
                                                            </div>
                                                            {errors.filter(e => e.path.join('-') === 'professional-contact-email').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'professional-contact-email')[0].message}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<div className="row y-gap-20 pt-20 items-center justify-end">
                                                    <div className="col-auto">
                                                        <a href="#" className="button-primary bg-primary d-block w-100">
                                                            Enregistrer
                                                        </a>
                                                    </div>
                                                </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                }
                                {booking.customerType === 'individual' &&
                                    <div className="accordion-item bg-bloc mb-30">
                                        <h2 className="accordion-header" id="booking_individual_accordion_heading">
                                            <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_individual_accordion_content" aria-expanded="false" aria-controls="booking_individual_accordion_content">
                                                <div className={"size-40 flex-center" + (errors.filter(e => e.path.join('-').indexOf('individual') === 0).length > 0 ? ' text-terracotta' : '')}>
                                                    <i className="fi fi-ss-circle-2" />
                                                </div>
                                                <div className={"ml-10 " + (errors.filter(e => e.path.join('-').indexOf('individual') === 0).length > 0 ? ' text-terracotta' : '')}>Informations sur le client</div>
                                            </button>
                                        </h2>
                                        <div id="booking_individual_accordion_content" className="accordion-collapse collapse" aria-labelledby="booking_individual_accordion_heading">
                                            <div className="accordion-body">
                                                <div className="row x-gap-20 y-gap-20 mb-10">
                                                    <div className="col-auto">
                                                        <label className="lh-1 text-light-1">Je suis :</label>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="d-flex items-center">
                                                            <div className="radio-wrapper">
                                                                <input type="radio" id="booking_individual_isLegalRepresentative_true" checked={booking.individual.isLegalRepresentative === true} onChange={() => {
                                                                    setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            isLegalRepresentative: true
                                                                        }
                                                                    })
                                                                }} />
                                                                <label htmlFor="booking_individual_isLegalRepresentative_true" className="mr-20">
                                                                    <span />
                                                                    {moment().diff(moment(booking.participants[0].dateOfBirth), 'years') >= 18 ?
                                                                        <>
                                                                            {[booking.participants[0].firstName, booking.participants[0].lastName].join('') === '' ? 'Le participant' : [booking.participants[0].firstName, booking.participants[0].lastName].join(' ')}
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {[booking.participants[0].legalRepresentatives[0].firstName, booking.participants[0].legalRepresentatives[0].lastName].join('') === '' ? 'Le réprésentant légal' : [booking.participants[0].legalRepresentatives[0].firstName, booking.participants[0].legalRepresentatives[0].lastName].join(' ')}
                                                                        </>
                                                                    }
                                                                </label>
                                                                <input type="radio" id="booking_individual_isLegalRepresentatice_false" checked={booking.individual.isLegalRepresentative === false} onChange={() => {
                                                                    setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            isLegalRepresentative: false
                                                                        }
                                                                    })
                                                                }} />
                                                                <label htmlFor="booking_individual_isLegalRepresentatice_false">
                                                                    <span />
                                                                    Une autre personne
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {booking.individual.isLegalRepresentative === false &&
                                                    <>
                                                        <div className="row x-gap-20 y-gap-20 pt-0">
                                                            {/*<h3>Informations sur l'entité</h3>*/}
                                                            <div className="col-md-2">
                                                                <Dropdown
                                                                    withLabel={false}
                                                                    className="small"
                                                                    options={{
                                                                        mrs: 'Mme',
                                                                        mr: 'M.',
                                                                    }}
                                                                    placeholder="..."
                                                                    value={booking.individual.civility}
                                                                    nullable={false}
                                                                    multiple={false}
                                                                    search={false}
                                                                    onChange={(civility: string) => {
                                                                        setBooking({
                                                                            ...booking,
                                                                            individual: {
                                                                                ...booking.individual,
                                                                                civility
                                                                            }
                                                                        })
                                                                    }}
                                                                />
                                                                {errors.filter(e => e.path.join('-') === 'individual-civility').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-civility')[0].message}</div>}
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-firstName').length > 0 ? ' requis' : ''} value={booking.individual.firstName} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            firstName: e.target.value
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Prénom
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-firstName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-firstName')[0].message}</div>}
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-lastName').length > 0 ? ' requis' : ''} value={booking.individual.lastName} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            lastName: e.target.value
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Nom
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-lastName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-lastName')[0].message}</div>}
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-address-address1').length > 0 ? ' requis' : ''} value={booking.individual.address.address1} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            address: {
                                                                                ...booking.individual.address,
                                                                                address1: e.target.value
                                                                            }
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        N° et nom de rue
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-address-address1').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-address-address1')[0].message}</div>}
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="form-input">
                                                                    <input type="text" value={booking.individual.address.address2} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            address: {
                                                                                ...booking.individual.address,
                                                                                address2: e.target.value
                                                                            }
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Complément d'adresse
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-address-postCode').length > 0 ? ' requis' : ''} value={booking.individual.address.postCode} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            address: {
                                                                                ...booking.individual.address,
                                                                                postCode: e.target.value
                                                                            }
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Code postal
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-address-postCode').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-address-postCode')[0].message}</div>}
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-address-city').length > 0 ? ' requis' : ''} value={booking.individual.address.city} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            address: {
                                                                                ...booking.individual.address,
                                                                                city: e.target.value
                                                                            }
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Commune
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-address-city').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-address-city')[0].message}</div>}
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-address-country').length > 0 ? ' requis' : ''} value={booking.individual.address.country} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            address: {
                                                                                ...booking.individual.address,
                                                                                country: e.target.value
                                                                            }
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Pays
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                    {errors.filter(e => e.path.join('-') === 'individual-address-country').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-address-country')[0].message}</div>}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-phones-0').length > 0 ? ' requis' : ''} value={booking.individual.phones[0] ?? ''} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            phones: [e.target.value]
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        N° de téléphone
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-phones-0').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-phones-0')[0].message}</div>}
                                                            </div>
                                                            <div className="col-md-7">
                                                                <div className="form-input">
                                                                    <input type="text" className={errors.filter(e => e.path.join('-') === 'individual-email').length > 0 ? ' requis' : ''} value={booking.individual.email} onChange={(e) => setBooking({
                                                                        ...booking,
                                                                        individual: {
                                                                            ...booking.individual,
                                                                            email: e.target.value
                                                                        }
                                                                    })} />
                                                                    <label className="lh-1 text-light-1">
                                                                        Adresse email
                                                                        <span className="obligatoire">*</span>
                                                                    </label>
                                                                </div>
                                                                {errors.filter(e => e.path.join('-') === 'individual-email').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'individual-email')[0].message}</div>}
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                {/*<div className="row y-gap-20 pt-20 items-center justify-end">
                                                    <div className="col-auto">
                                                        <a href="#" className="button-primary bg-primary d-block w-100">
                                                            Enregistrer
                                                        </a>
                                                    </div>
                                                </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="accordion-item bg-bloc mb-30">
                                    <h2 className="accordion-header" id="booking_financialAid_accordion_heading">
                                        <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_financialAid_accordion_content" aria-expanded="false" aria-controls="booking_financialAid_accordion_content">
                                            <div className="size-40 flex-center">
                                                <i className={"fi fi-ss-circle-3"} />
                                            </div>
                                            <div className="ml-10">Aides financières</div>
                                        </button>
                                    </h2>
                                    <div id="booking_financialAid_accordion_content" className="accordion-collapse collapse" aria-labelledby="booking_financialAid_accordion_heading">
                                        <div className="accordion-body">
                                            <div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-md-12">
                                                    <div className="d-flex items-center">
                                                        <div className="form-switch d-flex items-center">
                                                            {/*<div className="switch">
                                                                <input type="checkbox" />
                                                                <span className="switch__slider" />
                                                            </div>*/}
                                                            <div className="lh-1 ml-10">
                                                                Aide aux vacances accordée par une CAF
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-input">
                                                        <input type="text" value={booking.financialAid.caf.department} onChange={(e) => setBooking({
                                                            ...booking,
                                                            financialAid: {
                                                                ...booking.financialAid,
                                                                caf: {
                                                                    ...booking.financialAid.caf,
                                                                    department: e.target.value
                                                                }
                                                            }
                                                        })} />
                                                        <label className="lh-1 text-light-1">
                                                            N° de département CAF
                                                            {booking.financialAid.caf.active && <span className="obligatoire">*</span>}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-input">
                                                        <input type="text" value={booking.financialAid.caf.beneficiaryNumber} onChange={(e) => setBooking({
                                                            ...booking,
                                                            financialAid: {
                                                                ...booking.financialAid,
                                                                caf: {
                                                                    ...booking.financialAid.caf,
                                                                    beneficiaryNumber: e.target.value
                                                                }
                                                            }
                                                        })} />
                                                        <label className="lh-1 text-light-1">
                                                            N° allocataire
                                                            {booking.financialAid.caf.active && <span className="obligatoire">*</span>}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="divider" />
                                            <div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-md-12">
                                                    <div className="d-flex items-center">
                                                        <div className="form-switch d-flex items-center">
                                                            {/*<div className="switch">
                                                                <input type="checkbox" />
                                                                <span className="switch__slider" />
                                                            </div>*/}
                                                            <div className="lh-1 ml-10">
                                                                Aide aux vacances accordée par une MSA
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-input">
                                                        <input type="text" value={booking.financialAid.msa.department} onChange={(e) => setBooking({
                                                            ...booking,
                                                            financialAid: {
                                                                ...booking.financialAid,
                                                                msa: {
                                                                    ...booking.financialAid.msa,
                                                                    department: e.target.value
                                                                }
                                                            }
                                                        })} />
                                                        <label className="lh-1 text-light-1">
                                                            N° de département MSA
                                                            {booking.financialAid.msa.active && <span className="obligatoire">*</span>}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-input">
                                                        <input type="text" value={booking.financialAid.msa.beneficiaryNumber} onChange={(e) => setBooking({
                                                            ...booking,
                                                            financialAid: {
                                                                ...booking.financialAid,
                                                                msa: {
                                                                    ...booking.financialAid.msa,
                                                                    beneficiaryNumber: e.target.value
                                                                }
                                                            }
                                                        })} />
                                                        <label className="lh-1 text-light-1">
                                                            N° allocataire
                                                            {booking.financialAid.msa.active && <span className="obligatoire">*</span>}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="divider" />
                                            <div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-12">
                                                    <div className="form-input">
                                                        <textarea required rows={6} value={booking.financialAid.other} onChange={(e) => setBooking({
                                                            ...booking,
                                                            financialAid: {
                                                                ...booking.financialAid,
                                                                other: e.target.value
                                                            }
                                                        })} />
                                                        <label className="lh-1 text-light-1">
                                                            Autres aides financières sollicitées
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="divider" />
                                            <div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-12">
                                                    <h3>Codes de réduction</h3>
                                                    {booking.participants.map((participant, indexParticipant) => {
                                                        return (
                                                            <React.Fragment key={'participant-' + indexParticipant}>
                                                                {booking.participants.length > 1 &&
                                                                    <>
                                                                        <h4>{participant.firstName} {participant.lastName}</h4>
                                                                    </>
                                                                }
                                                                <div className="col-md-6">
                                                                    <DiscountCode
                                                                        aroeven={aroeven}
                                                                        prestation={bafad}
                                                                        supplier={bafad.proposedBy}
                                                                        apply={(discountCode: DiscountCode) => setParticipant(indexParticipant, {
                                                                            ...participant,
                                                                            discountCodes: [
                                                                                ...participant.discountCodes,
                                                                                discountCode
                                                                            ]
                                                                        })}
                                                                        discountCodes={participant.discountCodes}
                                                                    />
                                                                    {participant.discountCodes.map((discountCode, indexDiscountCode) => {
                                                                        return (
                                                                            <React.Fragment key={'discountCode-' + indexDiscountCode}>
                                                                                <h4 className="my-2">
                                                                                    <a href="#" onClick={(e) => {
                                                                                        e.preventDefault()
                                                                                        setParticipant(indexParticipant, {
                                                                                            ...participant,
                                                                                            discountCodes: Object.assign(
                                                                                                [...participant.discountCodes], {
                                                                                                [indexDiscountCode]: null
                                                                                            }
                                                                                            ).filter(code => code !== null)
                                                                                        })
                                                                                    }}><i className="fi fi-rr-cross-circle" /></a>
                                                                                    {discountCode.code}
                                                                                </h4>
                                                                            </React.Fragment>
                                                                        )
                                                                    })}
                                                                </div>

                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            {/*<div className="divider" />
                                            <div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-md-12">
                                                    <div className="d-flex items-center">
                                                        <div className="form-switch d-flex items-center">
                                                            <div className="switch">
                                                                <input type="checkbox" />
                                                                <span className="switch__slider" />
                                                            </div>
                                                            <div className="lh-1 ml-10">
                                                                Réduction accordée via un CSE
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-input">
                                                        <input type="text" required />
                                                        <label className="lh-1 text-light-1">
                                                            Code partenaire
                                                            <span className="obligatoire">*</span>
                                                        </label>
                                                    </div>
                                                    <span className="info">
                                                        Une remise de 20% a été accordée.
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="divider" />
                                            <div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-md-6">
                                                    <div className="form-input">
                                                        <input type="text" required />
                                                        <label className="lh-1 text-light-1">
                                                            Code promo (lycéen)
                                                            <span className="obligatoire">*</span>
                                                        </label>
                                                    </div>
                                                    <span className="info">
                                                        Une remise de 20% a été accordée.
                                                    </span>
                                                </div>
                                            </div>*/}
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item bg-bloc mb-30">
                                    <h2 className="accordion-header" id="booking_options_accordion_heading">
                                        <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_options_accordion_content" aria-expanded="false" aria-controls="booking_options_accordion_content">
                                            <div className="size-40 flex-center">
                                                <i className="fi fi-ss-circle-4" />
                                            </div>
                                            <div className="ml-10">Assurance annulation</div>
                                        </button>
                                    </h2>
                                    <div id="booking_options_accordion_content" className="accordion-collapse collapse" aria-labelledby="booking_options_accordion_heading">
                                        <div className="accordion-body">
                                            <div className="row">
                                                <div className="col-12">
                                                    {/*<div className="checkbox-wrapper">
                                                        <input type="checkbox" id="check7" name="check" defaultChecked disabled />
                                                        <label htmlFor="check7">
                                                            <span />
                                                            Option obligatoire : Adhésion à l’association pour
                                                            un montant de <b>0,00€</b>
                                                        </label>
                                                    </div>*/}
                                                    {/*<Checkbox
                                                        defaultChecked={booking.options.includes('membership')}
                                                        readonly={true}
                                                        label={<>Adhésion à l'association pour un montant de <b>{formatPrice(0)} €{booking.participants.length > 1 && <> par particiapnt</>}</b></>}
                                                        toggle={() => { }}
                                                    />*/}
                                                    <Checkbox
                                                        defaultChecked={booking.withInsurance === true}
                                                        label={<>Assurance annulation pour un supplément de <b>{formatPrice(booking.participants.reduce((total, participant) => total += participant.accomodationOption.insurancePrice, 0))} €</b> <a href={cancelationInsuranceTermsLink} target="_blank" onClick={(e) => e.stopPropagation()}><i className='fi fi-rr-interrogation' /></a></>}
                                                        toggle={() => {
                                                            setBooking({
                                                                ...booking,
                                                                withInsurance: !booking.withInsurance
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item bg-bloc mb-30">
                                    <h2 className="accordion-header" id="booking_payment_accordion_heading">
                                        <button className="accordion-button bg-bloc collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#booking_payment_accordion_content" aria-expanded="false" aria-controls="booking_payment_accordion_heading">
                                            <div className={"size-40 flex-center" + (errors.filter(e => e.path.join('-').indexOf('termsOfSale') === 0).length > 0 ? ' text-terracotta' : '')}>
                                                <i className="fi fi-ss-circle-5" />
                                            </div>
                                            <div className={"ml-10 " + (errors.filter(e => e.path.join('-').indexOf('termsOfSale') === 0).length > 0 ? ' text-terracotta' : '')}>Confirmation{bafad.proposedBy.paymentCardSystem in cardSystems && totalPrice > 0 && <> et paiement</>}</div>
                                        </button>
                                    </h2>
                                    <div id="booking_payment_accordion_content" className="accordion-collapse collapse" aria-labelledby="booking_payment_accordion_heading">
                                        <div className="accordion-body">
                                            {totalPrice >= 0 &&
                                                <>
                                                    <div className="row x-gap-20 y-gap-20 mb-10">
                                                        <div className="col-auto">
                                                            <label className="lh-1 text-light-1">Je souhaite régler :</label>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className="d-flex flex-column">
                                                                {bafad.proposedBy.paymentCardSystem in cardSystems &&
                                                                    <>
                                                                        <div className="radio-wrapper">
                                                                            <input type="radio" id={paymentModeRadioId + '-card'} checked={booking.payment.mode === 'card'} onChange={() => setBooking({
                                                                                ...booking,
                                                                                payment: {
                                                                                    ...booking.payment,
                                                                                    mode: 'card'
                                                                                }
                                                                            })} />
                                                                            <label htmlFor={paymentModeRadioId + '-card'} className="mr-20">
                                                                                <span />
                                                                                Par carte bancaire
                                                                            </label>
                                                                            <div className="col-auto">
                                                                                <img src={cardPaymentLogos.src} alt="image" className="logos-cb" />
                                                                            </div>
                                                                        </div>
                                                                        {booking.payment.mode === 'card' && moment(bafad.startDate1).diff(moment(), 'd') > 30 &&
                                                                            <div className="row montant">
                                                                                <div className="col-md-6">
                                                                                    <a href='#' onClick={(e) => {
                                                                                        e.preventDefault()
                                                                                        e.stopPropagation()
                                                                                        setBooking({
                                                                                            ...booking,
                                                                                            payment: {
                                                                                                ...booking.payment,
                                                                                                amountMode: 'full'
                                                                                            }
                                                                                        })
                                                                                    }}>
                                                                                        <div className={"condition px-24 py-20 bg-bloc mb-20" + (booking.payment.amountMode === 'full' ? ' active' : '')}>
                                                                                            <div className="row x-gap-20 y-gap-20 items-center">
                                                                                                <div className="col">
                                                                                                    <h5 className="lh-15 text-16 fw-500">Régler la totalité</h5>
                                                                                                    <div className="text-14 lh-15 fw-700 text-primary">{formatPrice(totalPrice)} €</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </a>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <a href='#' onClick={(e) => {
                                                                                        e.preventDefault()
                                                                                        e.stopPropagation()
                                                                                        setBooking({
                                                                                            ...booking,
                                                                                            payment: {
                                                                                                ...booking.payment,
                                                                                                amountMode: 'deposit'
                                                                                            }
                                                                                        })
                                                                                    }}>
                                                                                        <div className={"condition px-24 py-20 bg-bloc mb-20" + (booking.payment.amountMode === 'deposit' ? ' active' : '')}>
                                                                                            <div className="row x-gap-20 y-gap-20 items-center">
                                                                                                <div className="col">
                                                                                                    <h5 className="lh-15 text-16 fw-500">Régler l'acompte (30%)</h5>
                                                                                                    <div className="text-14 lh-15 fw-700 text-primary">{formatPrice(Math.ceil(totalPrice * 0.3))} €</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                }
                                                                <div className="radio-wrapper">
                                                                    <input type="radio" id={paymentModeRadioId + '-other'} checked={booking.payment.mode === 'other'} onChange={() => setBooking({
                                                                        ...booking,
                                                                        payment: {
                                                                            ...booking.payment,
                                                                            mode: 'other'
                                                                        }
                                                                    })} />
                                                                    <label htmlFor={paymentModeRadioId + '-other'}>
                                                                        <span />
                                                                        Autre moyen de paiement
                                                                    </label>
                                                                    <span className="info d-block">Chèque, virement ou espèces. Les modalités de paiement seront précisées à l'étape suivante.</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            <div className="row x-gap-20 y-gap-20 pt-0 d-flex justify-content-end">
                                                <Checkbox
                                                    defaultChecked={booking.termsOfSale === 'accepted'}
                                                    label={<>J'adhère à l'association et accepte les <a href={bafad.proposedBy.url + bafad.proposedBy.termsOfSalePage.pathname} target="_blank"><b>conditions générales de vente</b></a></>}
                                                    toggle={() => setBooking({
                                                        ...booking,
                                                        termsOfSale: booking.termsOfSale === 'accepted' ? '' : 'accepted'
                                                    })}
                                                />
                                                {errors.filter(e => e.path.join('-') === 'termsOfSale').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === 'termsOfSale')[0].message}</div>}
                                                <div className="col-auto d-flex align-items-end flex-column">
                                                    <div className="info mb-2">En cliquant sur le bouton ci-dessous, je confirme ma réservation.</div>
                                                    <a href="#" className="button-primary bg-primary d-inline-block" onClick={(e) => {
                                                        e.preventDefault()
                                                        sendBooking()
                                                    }}>Confirmer la réservation{booking.payment.mode === 'card' && getPayableAmount() > 0 && <> et payer {formatPrice(getPayableAmount())} €</>}</a>
                                                </div>
                                            </div>

                                            {errors.length > 0 &&
                                                <div className="alert alert-danger mt-30" role="alert">
                                                    <h4 className="alert-heading d-flex align-items-center lh-1">
                                                        <i className="fi fi-rr-shield-exclamation" />
                                                        <span>Le formulaire de réservation est incomplet ou contient des erreurs. Veuillez vérifier vos saisies.</span>
                                                    </h4>
                                                </div>
                                            }
                                            {serverError &&
                                                <div className="alert alert-danger mt-30" role="alert">
                                                    <h4 className="alert-heading d-flex align-items-center lh-1">
                                                        <i className="fi fi-rr-shield-exclamation" />
                                                        <span>La réservation n'a pas pu être effectuée{typeof serverError === 'object' && 'error' in serverError && <> ({serverError.error})</>}. En cas de problème, veuillez contacter {getStaffByRole(bafad.proposedBy, 'bafad')?.firstName ?? 'l\'Aroéven'} au {parsePhone(getStaffByRole(bafad.proposedBy, 'bafad')?.phone ?? bafad.proposedBy.phone)}.</span>
                                                    </h4>
                                                </div>
                                            }
                                            {paymentParams &&
                                                <>
                                                    <form ref={refPaymentForm} method="POST" action={paymentParams.url}>
                                                        {Object.entries(paymentParams.params).map(([name, value], indexParam) => {
                                                            return (
                                                                <React.Fragment key={"param-" + indexParam}>
                                                                    <input type="hidden" name={name} value={value} />
                                                                </React.Fragment>
                                                            )
                                                        })}
                                                    </form>
                                                </>
                                            }
                                            {/*<div className="row x-gap-20 y-gap-20 pt-0">
                                                <div className="col-md-12">
                                                    <button className="button-primary bg-primary w-100 d-block">
                                                        Confirmer la réservation{booking.payment.mode === 'card' && payableAmount > 0 && <> et payer {formatPrice(payableAmount)} €</>}
                                                    </button>
                                                </div>
                                            </div>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-4 relative order-first order-lg-2">
                            <Sidebar>
                                <div className="d-flex flex-column flex-md-row flex-lg-column justify-end" data-offset={450}>
                                    <div className="encart-1 ml-lg-0 px-30 py-30 bg-bloc w-360">
                                        <h4 className="titre">Votre réservation</h4>
                                        <div className="row y-gap-15 items-center justify-between">
                                            <div className="col-auto">
                                                <div className="text-14 text-light-1">
                                                    <h4>Organisé par :</h4>
                                                    <h4>
                                                        <a href="#" className="link">
                                                            {getName(bafad.proposedBy)}{bafad.partnershipOf ? <>, en partenariat avec {getName(bafad.partnershipOf.proposedBy)}</> : ''} <i className="fi fi-ss-angle-circle-right lh-15" />
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="col-auto text-ocre-dark numbers text-18">
                                                <i className="fi fi-rr-phone-flip" /> Contactez {getStaffByRole(bafad.proposedBy, 'bafad')?.firstName ?? 'l\'Aroéven'} au {parsePhone(getStaffByRole(bafad.proposedBy, 'bafad')?.phone ?? bafad.proposedBy.phone)}
                                            </div>
                                        </div>
                                        <div className="divider mt-10" />
                                        <div className="row x-gap-15 y-gap-20">
                                            <div className="col-auto">
                                                <img src={getMediaUrl(bafad.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.url ?? '#')} alt="image" className="size-120 object-cover" loading="lazy" />
                                            </div>
                                            <div className="col">
                                                <div className="d-flex x-gap-5 pb-10">
                                                    <div className="text-14 text-light-1">
                                                        <h4 className="text-ocre-dark mb-10">{levels[bafad.level]?.name}</h4>
                                                        {/*{holidayStay.thematic in thematics && <h5>{thematics[holidayStay.thematic]?.name}</h5>}
                                                        <h5>Tranche d'âge : {holidayStay.minAge}{holidayStay.minAge !== holidayStay.maxAge && <>-{holidayStay.maxAge}</>} ans</h5>
                                                        <span className="info">Ref : {bafad.reference}</span>*/}
                                                        <h5>du {moment(bafad.startDate1).format('DD/MM/YYYY')} au {moment(bafad.endDate1).format('DD/MM/YYYY')}</h5>
                                                        {bafad.reference && <span className="info">Ref : {bafad.reference}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row y-gap-20 pt-5">
                                            <div className="col-12">
                                                <div className="tarif">
                                                    <h4 className="py-3">Prix de la formation</h4>
                                                    {booking.participants.map((participant, indexParticipant) => {
                                                        return (
                                                            <React.Fragment key={"participant-" + indexParticipant}>
                                                                <div className="row justify-between">
                                                                    <div className="col-auto">
                                                                        <div>Formation {(participant.firstName || participant.lastName) ? participant.firstName + ' ' + participant.lastName : 'Participant ' + (indexParticipant + 1)}</div>
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        <div>{formatPrice(participant.accomodationOption.price)} €</div>
                                                                    </div>
                                                                </div>
                                                                {participant.options.length > 0 &&
                                                                    <div className="row justify-between">
                                                                        <div className="col-auto">
                                                                            <div>Options</div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div>{formatPrice(participant.options.reduce((price, option) => price + option.price, 0))} €</div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {participant.discountCodes.map((discountCode, indexDiscountCode) => {
                                                                    return (
                                                                        <React.Fragment key={'discountCode-' + indexDiscountCode}>
                                                                            <div className="row justify-between remise">
                                                                                <div className="col-auto">
                                                                                    <div>{discountCode.code}</div>
                                                                                </div>
                                                                                <div className="col-auto">
                                                                                    <div>-{formatPrice(discountCode.rate ? Math.ceil(participant.accomodationOption.price * discountCode.rate) : discountCode.amount)} €</div>
                                                                                </div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                    {/*<div className="row justify-between">
                                                        <div className="col-auto">
                                                            <div>Adhésion à l'association</div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div>0,00€</div>
                                                        </div>
                                                    </div>*/}
                                                    {booking.withInsurance &&
                                                        <div className="row justify-between">
                                                            <div className="col-auto">
                                                                <div>Assurance annulation</div>
                                                            </div>
                                                            <div className="col-auto">
                                                                <div>{formatPrice(booking.participants.reduce((total, participant) => total += participant.accomodationOption.insurancePrice, 0))} €</div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {/*<div className="row justify-between remise">
                                                        <div className="col-auto">
                                                            <div>Remise</div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div>-100,00€</div>
                                                        </div>
                                                    </div>*/}
                                                    <div className="col-auto">
                                                        <div className="d-flex justify-content-end">
                                                            <div className="text-14 text-right mt-10">
                                                                <div className="total">Total : {formatPrice(totalPrice)} €</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Sidebar>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

type ParticipantProps = {
    participant: Participant,
    setParticipant: Function,
    bafad: Bafad,
    errors: any[],
    errorPrefix: string,
    booking: Booking
}

function Participant({
    participant,
    setParticipant,
    errors,
    errorPrefix,
    bafad,
    booking
}: ParticipantProps) {

    const smsAgreementCheckboxId = useId()
    const photoAgreementCheckboxId = useId()
    const genderMaleRadioId = useId()
    const genderFemaleRadioId = useId()
    const genderNonBinaryRadioId = useId()
    const optionsCheckboxId = useId()

    function setLegalRepresentative(indexLegalRepresentative: number, legalRepresentative) {
        setParticipant({
            ...participant,
            legalRepresentatives: Object.assign(
                [...participant.legalRepresentatives], {
                [indexLegalRepresentative]: legalRepresentative
            }
            )
        })
    }

    useEffect(() => {
        async function load() {
            const bootstrap = (await import('bootstrap/dist/js/bootstrap')).default;
            document.querySelectorAll('[data-bs-toggle="tooltip"').forEach((tooltip) => {
                new bootstrap.Tooltip(tooltip)
            })
        }
        load()
    }, [])

    console.log('accomodationsOptions', bafad.accomodationOptions)

    useEffect(() => {
        if (participant.dateOfBirth === '') {
            if (participant.isAdult === true) {
                setParticipant({
                    ...participant,
                    isAdult: false
                })
            }
            return
        }
        if (moment(participant.dateOfBirth).isValid() === false) {
            if (participant.isAdult === true) {
                setParticipant({
                    ...participant,
                    isAdult: false
                })
            }
            return
        }
        if (moment().diff(moment(participant.dateOfBirth), 'years') >= 18) {
            if (participant.isAdult === false) {
                setParticipant({
                    ...participant,
                    isAdult: true
                })
            }
            return
        }
        if (participant.isAdult === true) {
            setParticipant({
                ...participant,
                isAdult: false
            })
        }
    }, [participant.dateOfBirth])


    const bafadAdministrationNumberTooltip = "L'inscription sur le site <a href=\"http://www.bafa-bafd.jeunes.gouv.fr\" target=\"blank_\">www.bafa-bafd.jeunes.gouv.fr</a>, est obligatoire avant de commencer un cursus BAFA ou BAFD. Il est également obligatoire pour continuer le cursus afin de vérifier la validation de votre stage pratique. Une copie de votre pièce d'identité valide vous sera demandée. Ce numéro est composé de 7 chiffres et de 4 lettres. Vous devez vous inscrire et suivre en ligne l’ensemble des démarches relatives aux diplômes suivants :<ul><li>Les cursus de formation BAFA et BAFD</li><li>Si vous êtes déjà titulaire du BAFA, les qualifications complémentaires : voile, canoë-kayak, activités de loisirs motocyclistes et surveillance de baignade</li><li>Si vous êtes déjà titulaire du BAFD ou d’une qualification surveillance de baignade, le renouvellement de votre diplôme</li></ul>"


    return (
        <>
            <div className="row x-gap-20 y-gap-20">
                <div className="col-auto">
                    <label className="lh-1 text-light-1">Sexe : <span className="obligatoire">*</span></label>
                </div>
                <div className="col-auto">
                    <div className="d-flex items-center">
                        <div className="radio-wrapper">
                            <input type="radio" id={genderMaleRadioId} checked={participant.gender === 'male'} onChange={() => setParticipant({
                                ...participant,
                                gender: 'male'
                            })} />
                            <label className={"mr-20" + (errors.filter(e => e.path.join('-') === errorPrefix + 'gender').length > 0 ? ' requis' : '')} htmlFor={genderMaleRadioId}>
                                <span />
                                Masculin
                            </label>
                            <input type="radio" id={genderFemaleRadioId} checked={participant.gender === 'female'} onChange={() => setParticipant({
                                ...participant,
                                gender: 'female'
                            })} />
                            <label className={"mr-20" + (errors.filter(e => e.path.join('-') === errorPrefix + 'gender').length > 0 ? ' requis' : '')} htmlFor={genderFemaleRadioId}>
                                <span />
                                Féminin
                            </label>
                            {/*<input type="radio" id={genderNonBinaryRadioId} checked={participant.gender === 'O'} onChange={() => setParticipant({
                                ...participant,
                                gender: 'O'
                            })} />
                            <label htmlFor={genderNonBinaryRadioId}>
                                <span />
                                Non binaire
                            </label>*/}
                        </div>
                        {errors.filter(e => e.path.join('-') === errorPrefix + 'gender').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'gender')[0].message}</div>}
                    </div>
                </div>
            </div>
            <div className="row x-gap-20 y-gap-20 pt-20">
                <div className="col-md-6">
                    <div className="form-input">
                        <input type="text" value={participant.firstName} className={(errors.filter(e => e.path.join('-') === errorPrefix + 'firstName').length > 0 ? ' requis' : '')} onChange={(e) => setParticipant({
                            ...participant,
                            firstName: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Prénom
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'firstName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'firstName')[0].message}</div>}
                </div>
                <div className="col-md-6">
                    <div className="form-input">
                        <input type="text" value={participant.lastName} className={(errors.filter(e => e.path.join('-') === errorPrefix + 'lastName').length > 0 ? ' requis' : '')} onChange={(e) => setParticipant({
                            ...participant,
                            lastName: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Nom
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'lastName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'lastName')[0].message}</div>}
                </div>
                <div className="col-md-6">
                    <div className="form-input">
                        <DateMask
                            className={(errors.filter(e => e.path.join('-') === errorPrefix + 'dateOfBirth').length > 0 ? ' requis' : '')}
                            value={moment(participant.dateOfBirth, 'YYYY-MM-DD')?.format('DD/MM/YYYY')}
                            onChange={(dateOfBirth) => setParticipant({
                                ...participant,
                                dateOfBirth
                            })}
                        />
                        {/*<input ref={refDateOfBirth} type="text" value={participant.dateOfBirth} className={(errors.filter(e => e.path.join('-') === errorPrefix + 'participant-dateOfBirth').length > 0 ? ' requis' : '')} onChange={(e) => setParticipant({
                            ...participant,
                            participant: {
                                ...participant,
                                dateOfBirth: e.target.value
                            }
                        })} />*/}
                        <label className="lh-1 text-light-1">
                            Date de naissance
                            <span className="obligatoire">*</span>
                        </label>
                        {/* <div class="date">
                        <i class="fi fi-rr-calendar text-primary-4"></i>
                      </div> */}
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'dateOfBirth').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'dateOfBirth')[0].message}</div>}
                </div>
                {/*<div className="col-md-6">
                    <div className="form-input">
                        <input type="text" required value={participant.placeOfBirth} onChange={(e) => setParticipant({
                            ...participant,
                            participant: {
                                ...participant,
                                placeOfBirth: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            Lieu de naissance
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                </div>*/}
                <div className="col-md-6">
                    <div className="form-input">
                        <input type="text" value={participant.email} className={(errors.filter(e => e.path.join('-') === errorPrefix + 'email').length > 0 ? ' requis' : '')} onChange={(e) => setParticipant({
                            ...participant,
                            email: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Adresse email
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'email').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'email')[0].message}</div>}
                </div>
                <div className="col-md-6">
                    <div className="form-input">
                        <input type="text" value={participant.phones[0]} className={(errors.filter(e => e.path.join('-') === errorPrefix + 'phones-0').length > 0 ? ' requis' : '')} onChange={(e) => setParticipant({
                            ...participant,
                            phones: [e.target.value]
                        })} />
                        <label className="lh-1 text-light-1">
                            Téléphone portable
                            {participant.isAdult === true && <span className="obligatoire">*</span>}
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'phones-0').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'phones-0')[0].message}</div>}
                    <div className="checkbox-wrapper">
                        <input type="checkbox" id={smsAgreementCheckboxId} checked={participant.agreesSMS} onChange={(e) => setParticipant({
                            ...participant,
                            agreesSMS: !participant.agreesSMS
                        })} />
                        <label htmlFor={smsAgreementCheckboxId}>
                            <span />
                            J'accepte de recevoir des SMS
                        </label>
                    </div>
                </div>
                <div className="col-12">
                    <h4 className="mb-2">N° {['bafd_advanced', 'bafd_initial'].includes(bafad.level) ? <>BAFD</> : <>BAFA</>} jeunes.gouv.fr <span data-bs-toggle="tooltip" data-bs-trigger="click" data-bs-placement="top" data-bs-custom-class="tooltip" data-bs-html="true" data-bs-title={bafadAdministrationNumberTooltip}><i className='fi fi-rr-interrogation' /></span></h4>
                    <div className="form-input">
                        <input type="text" value={participant.administrationNumber} className={(errors.filter(e => e.path.join('-') === errorPrefix + 'administrationNumber').length > 0 ? ' requis' : '')} onChange={(e) => setParticipant({
                            ...participant,
                            administrationNumber: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            N° {['bafd_advanced', 'bafd_initial'].includes(bafad.level) ? <>BAFD</> : <>BAFA</>} jeunes.gouv.fr
                            {/*<span className="obligatoire">*</span>*/}
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'administrationNumber').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'administrationNumber')[0].message}</div>}
                </div>
                <div className="col-12">
                    <h4 className="mb-2">Droit à l'image <span data-bs-toggle="tooltip" data-bs-trigger="click" data-bs-placement="top" data-bs-custom-class="tooltip" data-bs-title="Cocher cette case autorise, l’équipe de formation et l’organisateur du stage BAFA ou BAFD à photographier et filmer l’enfant inscrit durant cette formation. Cela autorise l'Aroéven organisatrice, les Aroéven conventionnées et la Fédération des Aroéven, à utiliser, fixer, reproduire et communiquer les photos et les vidéos réalisées lors du stage, dans la limite de durée légale. Les photos et les vidéos pourront être reproduites, en partie ou en totalité, sur tout support (papier, numérique, vidéo…) et intégrées à tout autre matériel (illustration, dessin, peinture, animation…) connu et à venir. Il est entendu que L'Aroéven et la Fédération des Aroéven s’interdisent expressément une exploitation des photographies ou des vidéos susceptibles de porter atteinte à la vie privée du stagiaire. 
Ni nom, ni adresse, n’apparaîtront dans l’utilisation qui peut en être faite. Les représentants légaux pourront demander à ce que les photographies et les vidéos ne soient plus utilisées, en informant, l’Aroéven d'inscription par courrier ou mail."><i className='fi fi-rr-interrogation' /></span></h4>
                    <div className="radio-wrapper">
                        <input type="radio" id={photoAgreementCheckboxId + '-true'} checked={participant.agreesPhotos === true} onChange={() => setParticipant({
                            ...participant,
                            agreesPhotos: true
                        })} />
                        <label htmlFor={photoAgreementCheckboxId + '-true'}>
                            <span />
                            J'autorise le droit à l'image
                        </label>
                    </div>
                    <div className="radio-wrapper">
                        <input type="radio" id={photoAgreementCheckboxId + '-false'} checked={participant.agreesPhotos === false} onChange={() => setParticipant({
                            ...participant,
                            agreesPhotos: false
                        })} />
                        <label htmlFor={photoAgreementCheckboxId + '-false'}>
                            <span />
                            Je n'autorise pas le droit à l'image
                        </label>
                    </div>
                </div>
                {/*<div className="col-md-6">
                    <div className="form-input">
                        <input type="text" required value={participant.nationality} onChange={(e) => setParticipant({
                            ...participant,
                            participant: {
                                ...participant,
                                nationality: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            Nationalité
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                </div>*/}
            </div>
            <div className="divider" />
            {moment().diff(moment(booking.participants[0].dateOfBirth), 'years') >= 18 ?
                <>
                    <div className="row x-gap-20 y-gap-20">
                        <h3>Adresse postale</h3>
                        <div className="col-12">
                            <div className="form-input">
                                <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-address1').length > 0 ? ' requis' : '')} value={participant.address.address1} onChange={(e) => setParticipant({
                                    ...participant,
                                    address: {
                                        ...participant.address,
                                        address1: e.target.value
                                    }
                                })} />
                                <label className="lh-1 text-light-1">
                                    N° et nom de rue
                                    <span className="obligatoire">*</span>
                                </label>
                            </div>
                            {errors.filter(e => e.path.join('-') === errorPrefix + 'address-address1').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-address1')[0].message}</div>}
                        </div>
                        <div className="col-12">
                            <div className="form-input">
                                <input type="text" value={participant.address.address2} onChange={(e) => setParticipant({
                                    ...participant,
                                    address: {
                                        ...participant.address,
                                        address2: e.target.value
                                    }
                                })} />
                                <label className="lh-1 text-light-1">
                                    Complément d'adresse
                                </label>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-input">
                                <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-postCode').length > 0 ? ' requis' : '')} value={participant.address.postCode} onChange={(e) => setParticipant({
                                    ...participant,
                                    address: {
                                        ...participant.address,
                                        postCode: e.target.value
                                    }
                                })} />
                                <label className="lh-1 text-light-1">
                                    Code postal
                                    <span className="obligatoire">*</span>
                                </label>
                            </div>
                            {errors.filter(e => e.path.join('-') === errorPrefix + 'address-postCode').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-postCode')[0].message}</div>}
                        </div>
                        <div className="col-md-5">
                            <div className="form-input">
                                <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-city').length > 0 ? ' requis' : '')} value={participant.address.city} onChange={(e) => setParticipant({
                                    ...participant,
                                    address: {
                                        ...participant.address,
                                        city: e.target.value
                                    }
                                })} />
                                <label className="lh-1 text-light-1">
                                    Commune
                                    <span className="obligatoire">*</span>
                                </label>
                            </div>
                            {errors.filter(e => e.path.join('-') === errorPrefix + 'address-city').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-city')[0].message}</div>}
                        </div>
                        <div className="col-md-4">
                            {/*<div className="select small libelle js-select" data-select-value>
                        <button className="select__button js-button">
                            <span className="js-button-title">Pays</span>
                            <i className="fi fi-bs-angle-down text-primary-4" />
                        </button>
                        <div className="select__dropdown js-dropdown">
                            <div className="select__options js-options">
                                <div className="select__options__button" data-value>
                                    Pays 2
                                </div>
                                <div className="select__options__button" data-value>
                                    Pays 3
                                </div>
                            </div>
                        </div>
                    </div>*/}
                            <div className="form-input">
                                <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-country').length > 0 ? ' requis' : '')} value={participant.address.country} onChange={(e) => setParticipant({
                                    ...participant,
                                    address: {
                                        ...participant.address,
                                        country: e.target.value
                                    }
                                })} />
                                <label className="lh-1 text-light-1">
                                    Pays
                                    <span className="obligatoire">*</span>
                                </label>
                            </div>
                            {errors.filter(e => e.path.join('-') === errorPrefix + 'address-country').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-country')[0].message}</div>}
                        </div>
                    </div>
                </>
                :
                <>
                    <LegalRepresentative
                        legalRepresentative={participant.legalRepresentatives[0]}
                        setLegalRepresentative={(legalRepresentative) => setLegalRepresentative(0, legalRepresentative)}
                        errors={errors}
                        errorPrefix={errorPrefix + 'legalRepresentatives-0-'}
                        booking={booking}
                    />
                </>
            }
            <div className="divider" />
            <div className="row x-gap-20 y-gap-20">
                <h3>Mode d'accueil</h3>
                <div className="col-lg-6">
                    <Dropdown
                        withLabel={true}
                        options={bafad.accomodationOptions.reduce((options: any, accomodationOption: any) => {
                            return {
                                ...options,
                                [accomodationOption.id]: {
                                    label: accomodationTypes[accomodationOption.accomodationType]?.name,
                                    sub: formatPrice(accomodationOption.price) + '€'
                                }
                            }
                        }, {})}
                        subTitle="Mode d'accueil"
                        value={participant.accomodationOption.id}
                        nullable={false}
                        multiple={false}
                        search={false}
                        onChange={(value: string) => {
                            setParticipant({
                                ...participant,
                                accomodationOption: bafad.accomodationOptions.filter(o => o.id === value)[0] ?? bafad.accomodationOptions[0]
                            })
                        }}
                    />
                </div>
            </div>
            {bafad.options.length > 0 &&
                <>
                    <div className="divider" />
                    <div className="row x-gap-20 y-gap-20">
                        <h3>Option(s)</h3>
                        <div className="col-md-6">
                            {bafad.options.map((option, indexOption) => {
                                return (
                                    <React.Fragment key={'option-' + indexOption}>
                                        <div className="checkbox-wrapper">
                                            <input type="checkbox" id={optionsCheckboxId + '-' + option.id} checked={participant.options.map(o => o.id).includes(option.id)} onChange={(e) => setParticipant({
                                                ...participant,
                                                options: participant.options.map(o => o.id).includes(option.id) ? participant.options.filter((o, i) => i !== participant.options.map(o => o.id).indexOf(option.id)) : [...participant.options, option]
                                            })} />
                                            <label htmlFor={optionsCheckboxId + '-' + option.id}>
                                                <span />
                                                {option.name}: {formatPrice(option.price)} €
                                            </label>
                                        </div>
                                    </React.Fragment>
                                )
                            })}
                        </div>
                    </div>
                </>
            }
        </>
    )

}

type LegalRepresentativeProps = {
    legalRepresentative: LegalRepresentative,
    setLegalRepresentative: Function,
    errors: any[],
    errorPrefix: string,
    booking: Booking
}

function LegalRepresentative({
    legalRepresentative,
    setLegalRepresentative,
    errors,
    errorPrefix,
    booking
}: LegalRepresentativeProps) {

    const required = booking.customerType === 'individual' && legalRepresentative.type !== 'other'

    return (
        <>
            <div className="row x-gap-20 y-gap-20">
                <h3>Responsable légal / Famille d'accueil / Educateur</h3>
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-6">
                            <Dropdown
                                withLabel={true}
                                options={{
                                    mother: 'Mère',
                                    father: 'Père',
                                    legalGuardian: 'Tuteur légal',
                                    other: 'Autre'
                                }}
                                subTitle="Type de responsable"
                                placeholder="Choisir..."
                                value={legalRepresentative.type}
                                nullable={false}
                                multiple={false}
                                search={false}
                                className={errors.filter(e => e.path.join('-') === errorPrefix + 'type').length > 0 ? ' requis' : ''}
                                onChange={(type: string) => {
                                    setLegalRepresentative({
                                        ...legalRepresentative,
                                        type
                                    })
                                }}
                            />
                            {errors.filter(e => e.path.join('-') === errorPrefix + 'type').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'type')[0].message}</div>}
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <Dropdown
                        withLabel={false}
                        className={"small" + (errors.filter(e => e.path.join('-') === errorPrefix + 'civility').length > 0 ? ' requis' : '')}
                        options={{
                            mrs: 'Mme',
                            mr: 'M.',
                        }}
                        placeholder="..."
                        value={legalRepresentative.civility}
                        nullable={false}
                        multiple={false}
                        search={false}
                        onChange={(civility: string) => {
                            setLegalRepresentative({
                                ...legalRepresentative,
                                civility
                            })
                        }}
                    />
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'civility').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'civility')[0].message}</div>}
                </div>
                <div className="col-md-5">
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'firstName').length > 0 ? ' requis' : '')} value={legalRepresentative.firstName} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            firstName: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Prénom
                            {required && <span className="obligatoire">*</span>}
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'firstName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'firstName')[0].message}</div>}
                </div>
                <div className="col-md-5">
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'lastName').length > 0 ? ' requis' : '')} value={legalRepresentative.lastName} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            lastName: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Nom
                            {required && <span className="obligatoire">*</span>}
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'lastName').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'lastName')[0].message}</div>}
                </div>
                <div className="col-md-12">
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'email').length > 0 ? ' requis' : '')} value={legalRepresentative.email} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            email: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Adresse email
                            {required && <span className="obligatoire">*</span>}
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'email').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'email')[0].message}</div>}
                </div>
                {legalRepresentative.phones.map((phone, indexPhone) => {
                    return (
                        <React.Fragment key={'phone-' + indexPhone}>
                            <div className="col-md-6">
                                <div className="form-input">
                                    <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'phones-' + indexPhone).length > 0 ? ' requis' : '')} value={phone} onChange={(e) => setLegalRepresentative({
                                        ...legalRepresentative,
                                        phones: Object.assign(
                                            [...legalRepresentative.phones], {
                                            [indexPhone]: e.target.value
                                        })
                                    })} />
                                    <label className="lh-1 text-light-1">
                                        Téléphone {indexPhone + 1}
                                        {required && <span className="obligatoire">*</span>}
                                    </label>
                                </div>
                                {errors.filter(e => e.path.join('-') === errorPrefix + 'phones-' + indexPhone).length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'phones-' + indexPhone)[0].message}</div>}
                                {indexPhone === 0 &&
                                    <div className="checkbox-wrapper">
                                        <input type="checkbox" id="check1" name="check" />
                                        <label htmlFor="check1">
                                            <span />
                                            J'accepte de recevoir des SMS
                                        </label>
                                    </div>
                                }
                            </div>
                        </React.Fragment>
                    )
                })}
                {legalRepresentative.phones.length < 3 &&
                    <div className="col-md-6">
                        <button className="button-outline d-block w-100" onClick={(e) => {
                            e.preventDefault()
                            setLegalRepresentative({
                                ...legalRepresentative,
                                phones: [
                                    ...legalRepresentative.phones,
                                    ''
                                ]
                            })
                        }}>
                            <i className="fi fi-rr-plus mr-5" />
                            Ajouter un N° de téléphone
                        </button>
                    </div>
                }
                {/*<div className="col-md-6">
                    <Dropdown
                        withLabel={false}
                        className="small"
                        options={{
                            single: 'Célibataire',
                            married: 'Marié',
                            divorced: 'Divorcé',
                            cohabitaiton: 'Concubinage',
                            pacs: 'Pacsé',
                            other: 'Autre'
                        }}
                        placeholder={<><span className="js-button-title">
                            Etat civil
                            <span className="obligatoire">*</span>
                        </span>
                        </>}
                        value={legalRepresentative.maritalStatus}
                        nullable={false}
                        multiple={false}
                        search={false}
                        onChange={(maritalStatus: string) => {
                            setLegalRepresentative({
                                ...legalRepresentative,
                                legalRepresentative: {
                                    ...legalRepresentative,
                                    maritalStatus
                                }
                            })
                        }}
                    />
                </div>*/}
                {/*<div className="col-md-6">
                    <Dropdown
                        withLabel={false}
                        className="small"
                        options={{
                            cat1: 'Agriculteurs exploitants',
                            cat2: 'Artisans, commerçants, chefs d\'entreprise',
                            cat3: 'Cadres, professions intellectuelles supérieures',
                            cat4: 'Professions intermédiaires',
                            cat5: 'Employés',
                            cat6: 'Ouvriers',
                            cat7: 'Retraités',
                            cat8: 'Sans activitié professionnelle'
                        }}
                        placeholder={<><span className="js-button-title">
                            Catégorie socio-professionnelle
                            <span className="obligatoire">*</span>
                        </span>
                        </>}
                        value={legalRepresentative.socialProfessionalCategory}
                        nullable={false}
                        multiple={false}
                        search={false}
                        onChange={(socialProfessionalCategory: string) => {
                            setLegalRepresentative({
                                ...legalRepresentative,
                                legalRepresentative: {
                                    ...legalRepresentative,
                                    socialProfessionalCategory
                                }
                            })
                        }}
                    />
                </div>*/}
            </div>
            <div className="divider" />
            <div className="row x-gap-20 y-gap-20">
                <h3>Adresse postale</h3>
                <div className="col-12">
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-address1').length > 0 ? ' requis' : '')} value={legalRepresentative.address.address1} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            address: {
                                ...legalRepresentative.address,
                                address1: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            N° et nom de rue
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'address-address1').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-address1')[0].message}</div>}
                </div>
                <div className="col-12">
                    <div className="form-input">
                        <input type="text" value={legalRepresentative.address.address2} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            address: {
                                ...legalRepresentative.address,
                                address2: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            Complément d'adresse
                        </label>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-postCode').length > 0 ? ' requis' : '')} value={legalRepresentative.address.postCode} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            address: {
                                ...legalRepresentative.address,
                                postCode: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            Code postal
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'address-postCode').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-postCode')[0].message}</div>}
                </div>
                <div className="col-md-5">
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-city').length > 0 ? ' requis' : '')} value={legalRepresentative.address.city} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            address: {
                                ...legalRepresentative.address,
                                city: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            Commune
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'address-city').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-city')[0].message}</div>}
                </div>
                <div className="col-md-4">
                    {/*<div className="select small libelle js-select" data-select-value>
                        <button className="select__button js-button">
                            <span className="js-button-title">Pays</span>
                            <i className="fi fi-bs-angle-down text-primary-4" />
                        </button>
                        <div className="select__dropdown js-dropdown">
                            <div className="select__options js-options">
                                <div className="select__options__button" data-value>
                                    Pays 2
                                </div>
                                <div className="select__options__button" data-value>
                                    Pays 3
                                </div>
                            </div>
                        </div>
                    </div>*/}
                    <div className="form-input">
                        <input type="text" className={(errors.filter(e => e.path.join('-') === errorPrefix + 'address-country').length > 0 ? ' requis' : '')} value={legalRepresentative.address.country} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            address: {
                                ...legalRepresentative.address,
                                country: e.target.value
                            }
                        })} />
                        <label className="lh-1 text-light-1">
                            Pays
                            <span className="obligatoire">*</span>
                        </label>
                    </div>
                    {errors.filter(e => e.path.join('-') === errorPrefix + 'address-country').length > 0 && <div className="f-requis">{errors.filter(e => e.path.join('-') === errorPrefix + 'address-country')[0].message}</div>}
                </div>
            </div>
            {/*
            <div className="divider" />
            <div className="row x-gap-20 y-gap-20">
                <div className="col-12">
                    <div className="form-input">
                        <textarea required rows={6} value={legalRepresentative.message} onChange={(e) => setLegalRepresentative({
                            ...legalRepresentative,
                            message: e.target.value
                        })} />
                        <label className="lh-1 text-light-1">
                            Autre information que vous souhaiteriez transmettre
                        </label>
                    </div>
                </div>
            </div>*/}
        </>
    )
}